function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 2L12 4V2.5C9.28046 2.5 7.91913 4.27449 6.4 6.3L6.3595 6.35401C4.88915 8.31484 3.25059 10.5 0 10.5V9.5C2.71954 9.5 4.08087 7.72551 5.6 5.7L5.6405 5.64599C7.11085 3.68516 8.74941 1.5 12 1.5V0L15 2Z",
  fill: "#BABABA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 12L15 10L12 8V9.5C10.2193 9.49987 9.02266 8.73757 7.98757 7.65454L7.26465 8.34546C8.42368 9.55817 9.86494 10.4999 12 10.5V12Z",
  fill: "#BABABA"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 2.5C1.78091 2.5 2.97769 3.26234 4.01287 4.34546L4.7358 3.65453C3.57668 2.44174 2.13531 1.5 0 1.5V2.5Z",
  fill: "#BABABA"
});

var SvgIconShuffle = function SvgIconShuffle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconShuffle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_shuffle.f421b239.svg";
export { ForwardRef as ReactComponent };